import React from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';

import { AudienceBroadcastMessageStatus } from '@occc/graphql';
import { MoreVertIcon } from '@occc/ui-design-system';

import { archivableStatuses } from '../messaging-campaigns-list.constants';
import { getIsEditableByStatus } from '../../messaging-campaign-update/messaging-campaign-update.utils';

export type MessagingCampaignsListItemContextMenuProps = {
  campaignUuid: string;
  status: AudienceBroadcastMessageStatus;
  isUserPermittedToEdit: boolean;
  onEditClick: (campaignUuid: string) => void;
  isUserPermittedToArchive: boolean;
  onArchiveClick: (campaignUuid: string) => void;
  onViewDetailsClick: (campaignUuid: string) => void;
};

export const MessagingCampaignsListItemContextMenu = (
  props: MessagingCampaignsListItemContextMenuProps,
) => {
  const {
    campaignUuid,
    status,
    isUserPermittedToEdit,
    onEditClick,
    isUserPermittedToArchive,
    onArchiveClick,
    onViewDetailsClick,
  } = props;

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const isContextMenuOpen = Boolean(anchorEl);
  const handleContextMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleContextMenuClose = (event: React.MouseEvent<unknown>) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  const shouldRenderEditOption = isUserPermittedToEdit && getIsEditableByStatus(status);
  const shouldRenderArchiveOption = isUserPermittedToArchive && archivableStatuses.includes(status);

  return (
    <>
      <IconButton
        id='context-menu-button'
        aria-controls={isContextMenuOpen ? 'context-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={isContextMenuOpen ? 'true' : undefined}
        onClick={handleContextMenuClick}
        sx={{ m: -1 }}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id='context-menu'
        anchorEl={anchorEl}
        open={isContextMenuOpen}
        onClose={handleContextMenuClose}
        MenuListProps={{
          'aria-labelledby': 'context-menu-button',
        }}
      >
        <MenuItem
          onClick={(event) => {
            onViewDetailsClick(campaignUuid);
            handleContextMenuClose(event);
          }}
        >
          View Details
        </MenuItem>
        {shouldRenderEditOption && (
          <MenuItem
            onClick={(event) => {
              onEditClick(campaignUuid);
              handleContextMenuClose(event);
            }}
          >
            Edit
          </MenuItem>
        )}
        {shouldRenderArchiveOption && (
          <MenuItem
            onClick={(event) => {
              onArchiveClick(campaignUuid);
              handleContextMenuClose(event);
            }}
          >
            Archive
          </MenuItem>
        )}
      </Menu>
    </>
  );
};
